module.exports = __webpack_public_path__ + "static/email-template-sso-a617ba2cb8307961ede86da17f06732c.png";